//============================================================================
// Name        : ls_sync_base.ts
// Purpose     : Base class to provide dialog helpers, etc.
// Created     : 2020-12-27
// Author      : Senitron Team
// Copyright   : Copyright 2020 Senitron Corporation. All rights reserved.
//============================================================================

import axios from "axios";

declare var App: any;
declare const storeLocation: string;

export interface IChannelData {
    message: string;
    inProgress: boolean;
    success: boolean;
    tag: string;
}

export class LsSyncBase {
    dialogId: string;
    subscription: any;
    const;
    syncDialogContinueButton                  = $("#syncDialog .continueBtn");
    syncDialogDoSyncButton                    = $("#syncDialog .doSyncBtn");
    downloadDialogContinueButton              = $("#downloadDialog .continueBtn");
    syncCategoriesDialogContinueButton        = $("#syncCategoriesDialog .continueBtn");
    syncCategoriesDialogDoSyncButton          = $("#syncCategoriesDialog .doSyncBtn");
    syncDialogReDownloadCheckBox              = $("#syncDialog #re_download_lightspeed_inventory");
    // syncDialogCheckLsAccessButton             = $("#syncDialog .checkLsAccessBtn");
    // downloadDialogCheckLsAccessButton         = $("#downloadDialog .checkLsAccessBtn");
    // syncCategoriesDialogCheckLsAccessButton   = $("#syncCategoriesDialog .checkLsAccessBtn");

    constructor(dialogId: string) {
        this.dialogId = dialogId;
        $(`#${this.dialogId} .close`).on("click", () => { this.hide(); });
    }

    connectLScable(dialogId: string, receivedHandler: (data: any) => void): void {
        App.lsSyncChannel = App.cable.subscriptions.create(
            { // Connection configuration
                channel: "LightspeedSyncChannel",
                roomId: `ls_sync_${storeLocation}`
            },
            { // Pass in connection callbacks
                connected() {
                    console.log("connected to sync channel");
                    // $(`#${dialogId} .checkLsAccessBtn`).removeProp("disabled");
                    $(`#${dialogId} .continueBtn`).removeProp("disabled");
                },
                disconnected() {
                    console.log("disconnected to sync channel");
                    App.cable.subscriptions.remove(this);
                    // $(`#${dialogId} .checkLsAccessBtn`).prop("disabled", true);
                    $(`#${dialogId} .continueBtn`).prop("disabled", true);
                },
                received: (data: any) => receivedHandler(data)
            }
        );
        this.subscription = App.lsSyncChannel;
    }

    disconnect(): void {
        //console.log("App.cable.subscriptions details: ", App.cable.subscriptions);
        App.cable.disconnect();
    }

    hide(): void {
        this.disconnect();
        $(`#${this.dialogId}`).modal("hide");
    }

    refreshPage(): void {
        window.location.reload();
    }

    static UpdateCurrentStatus(dialogId: string, statusMsg: string, inProgress: boolean, success: boolean): void {
        $(".currentStatus .statusDesc").html(statusMsg);
        if (inProgress) {
            $(".currentStatus .progress-spin").fadeIn();
        }
        else {
            $(".currentStatus .progress-spin").fadeOut();
        }

        if (success) {
            $(".currentStatus .success-img").show();
            $(".currentStatus .fail-img").hide();
        }
        else {
            $(".currentStatus .success-img").hide();
            $(".currentStatus .fail-img").show();
        }

        if (!inProgress && success) {
            $(`#${dialogId} .previewSyncBtn`).removeAttr("disabled");
            $(`#${dialogId} .previewSyncBtn`).attr("href", $(`#${dialogId} .previewSyncBtn`).data("href"));
            $(`#${dialogId} .doSyncBtn`).removeProp("disabled");
        }
    }

    static UpdateFinalStatus(statusMsg: string, inProgress: boolean, success: boolean): void {
        $(".finalStatus .statusDesc").html(statusMsg);
        if (inProgress) {
            $(".finalStatus .progress-spin").fadeIn();
        }
        else {
            $(".finalStatus .progress-spin").fadeOut();
        }

        if (success) {
            $(".finalStatus .success-img").show();
            $(".finalStatus .fail-img").hide();
        }
        else {
            $(".finalStatus .success-img").hide();
            $(".finalStatus .fail-img").show();
        }
    }

    // static UpdateCheckLSAccessStatus(dialogId: string, statusMsg: string, inProgress: boolean, success: boolean): void {
    //     $(`#${dialogId} .checkLSAccessStatus .statusDesc`).html(statusMsg);
    //     if (inProgress) {
    //         $(`#${dialogId} .checkLSAccessStatus .progress-spin`).fadeIn();
    //     }
    //     else {
    //         $(`#${dialogId} .checkLSAccessStatus .progress-spin`).fadeOut();
    //     }
    //
    //     if (success) {
    //         $(`#${dialogId} .checkLSAccessStatus .success-img`).show();
    //         $(`#${dialogId} .checkLSAccessStatus .fail-img`).hide();
    //     }
    //     else {
    //         $(`#${dialogId} .checkLSAccessStatus .success-img`).hide();
    //         $(`#${dialogId} .checkLSAccessStatus .fail-img`).show();
    //     }
    //
    //     if (success && inProgress) {
    //         $(`#${dialogId} .checkLSAccessStatus .progress-spin`).fadeOut();
    //         $(`#${dialogId} .checkLSAccessStatus`).show();
    //     }
    // }

    showRefreshBtn(): void  {
        $(".refreshBtn").on("click", () => location.reload());
        $(".refreshBtn").siblings().remove();
        $(".refreshBtn").removeClass("hidden");
    }
}
